import React, { useState } from 'react';
import './CSVImport.css';

const CSVImport = ({ onProductsImport }) => {
  const [csvContent, setCsvContent] = useState('');
  const [error, setError] = useState('');

  const parsePrice = (priceStr) => {
    if (!priceStr) return 0;
    
    // Loại bỏ ₫, khoảng trắng
    let cleaned = priceStr.replace(/₫|,\s*/g, '').trim();
    
    // Xử lý định dạng "57,0k" → 57000
    if (cleaned.includes('k')) {
      const num = parseFloat(cleaned.replace('k', ''));
      return Math.round(num * 1000);
    }
    
    return parseInt(cleaned) || 0;
  };

  const parseCSV = (csvText) => {
    try {
      setError('');
      const lines = csvText
        .trim()
        .split('\n')
        .filter((line) => line.trim());

      if (lines.length === 0) {
        setError('CSV không chứa dữ liệu nào');
        return [];
      }

      // Bỏ dòng header (dòng đầu tiên)
      const dataLines = lines.slice(1);

      if (dataLines.length === 0) {
        setError('CSV chỉ có header, không có dữ liệu sản phẩm');
        return [];
      }

      const products = dataLines.map((line, idx) => {
        // Parse CSV với xử lý quotes
        const parts = [];
        let current = '';
        let inQuotes = false;
        
        for (let i = 0; i < line.length; i++) {
          const char = line[i];
          if (char === '"') {
            inQuotes = !inQuotes;
          } else if (char === ',' && !inQuotes) {
            parts.push(current.trim());
            current = '';
          } else {
            current += char;
          }
        }
        parts.push(current.trim());

        // Cần ít nhất 9 cột
        if (parts.length < 9) {
          throw new Error(
            `Dòng ${idx + 2}: Thiếu cột. Cần 9 cột, chỉ có ${parts.length}`
          );
        }

        // Cột: 0=Mã, 1=Tên, 2=Giá, 3=Doanh thu, 4=Cửa hàng, 5=Tỉ lệ, 6=Hoa hồng, 7=Link SP, 8=Link ưu đãi
        return {
          product: parts[1] || '',
          price: parsePrice(parts[2]),
          url: parts[8] || '',
          productLink: parts[7] || '',
          img: '',
          category: '',
        };
      });

      return products;
    } catch (err) {
      setError(`Lỗi khi parse CSV: ${err.message}`);
      return [];
    }
  };

  const handlePaste = (e) => {
    const text = e.target.value;
    setCsvContent(text);
  };

  const handleImport = () => {
    const products = parseCSV(csvContent);
    if (products.length > 0) {
      onProductsImport(products);
      setCsvContent('');
      setError('');
    }
  };

  const handleClear = () => {
    setCsvContent('');
    setError('');
  };

  return (
    <div className="csv-import-container">
      <div className="csv-import-card">
        <h3>Nhập CSV sản phẩm</h3>
        <p className="csv-import-hint">
          Định dạng Shopee: Lấy các cột Tên sản phẩm, Giá, Link sản phẩm, Link ưu đãi từ CSV
        </p>
        <textarea
          value={csvContent}
          onChange={handlePaste}
          placeholder={`Paste CSV từ Shopee (bao gồm header)\nCác cột cần: Tên sản phẩm, Giá, Link sản phẩm, Link ưu đãi`}
          className="csv-textarea"
          rows="8"
        />
        {error && <div className="error-message">{error}</div>}
        <div className="csv-import-actions">
          <button onClick={handleImport} className="btn btn-import">
            Nhập ({csvContent.split('\n').filter((line) => line.trim()).length} dòng)
          </button>
          <button onClick={handleClear} className="btn btn-clear">
            Xóa
          </button>
        </div>
      </div>
    </div>
  );
};

export default CSVImport;
